import { mapGetters } from "vuex";

export default {
    name: "order-item",
    props: ["product"],
    computed: {
        ...mapGetters({
            user: "profile/user",
        }),
        // bonuses are credited by the backend (after LiqPay success or "received"); until then they are null
        creditedBonuses() {
            return this.product.bonuses ? parseFloat(this.product.bonuses).toFixed(2) : "—";
        },
    },
};
